import Vue from 'vue';

Vue.component('CustomFieldPin', () => import('@/components/genericForm/fields/PinField.vue'));
